<template>
  <div class="chapter">
    <section class="section__header section__skewed--bottom">
      <div class="container pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12 text-center">
            <img src="@/assets/images/shiseido_logo_white.svg" class="img-fluid" data-aos="fade-up" data-aos-delay="600">
            <h1 class="color-white font-size-120 font-bold mt-8 mt-lg-12" data-aos="fade-up" data-aos-delay="600" v-html="$t('PAGE02_TEXT01')">All about eyes</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="section__allabouteyes section__allabouteyes--01 mb-5">
      <div class="container mb-15 pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-10 offset-1 text-center">
            <div class="box">
              <p class="font-bold font-size-32 color-highlight" data-aos="fade-up" data-aos-delay="800" v-html="$t('PAGE02_TEXT02')">What visible changes do you notice in your skin
                when you are suffering from tiredness and fatigue?</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12 mini-quiz">
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="50">
              <div class="answer" v-html="$t('PAGE02_TEXT03')">Dark circles</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="100">
              <div class="answer" v-html="$t('PAGE02_TEXT04')">Eye bags</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="150">
              <div class="answer" v-html="$t('PAGE02_TEXT05')">Dryness</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="200">
              <div class="answer" v-html="$t('PAGE02_TEXT06')">Hyper pigmentation</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="250">
              <div class="answer" v-html="$t('PAGE02_TEXT07')">Puffiness</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="300">
              <div class="answer" v-html="$t('PAGE02_TEXT08')">Sagging</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="350">
              <div class="answer" v-html="$t('PAGE02_TEXT09')">Wrinkles</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="400">
              <div class="answer" v-html="$t('PAGE02_TEXT10')">Loss of firmness</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="450">
              <div class="answer" v-html="$t('PAGE02_TEXT11')">Loss of resilience</div>
            </div>
            <div class="answer__item" data-aos="zoom-in" data-aos-delay="500">
              <div class="answer--check" v-on:click="showAdditionalContent()" v-html="$t('PAGE02_TEXT12')">see result</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section__allabouteyes section__allabouteyes--02 mb-5" id="section__allabouteyes--02" :class="{'d-none': additionalContent == false}" ref="scrollTo">
      <div class="container pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-10 offset-1 text-center">
            <p class="font-bold font-size-120 color-highlight" data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT13')">You are right !</p>
            <p class="color-highlight mb-4" data-aos="fade-up" data-aos-delay="20" v-html="$t('PAGE02_TEXT14')">All of the answers are visible changes you can notice when your are suffering
              from tiredness and fatigue.</p>
            <p data-aos="fade-up" data-aos-delay="30" v-html="$t('PAGE02_TEXT15')">And it’s not just the mature customers that notice
              these changes around the eyes, it's all of us!</p>
          </div>
        </div>
      </div>
      <div class="position-absolute purple-line" data-aos="fade-up" data-aos-delay="600"></div>
    </section>
    <section
        class="section__allabouteyes section__allabouteyes--03 section__highlight section__skewed--top section__skewed--bottom"
        :class="{'d-none': additionalContent == false}">

      <div class="container pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12">
            <h3 class="font-bold font-size-56 mb-5" data-aos="fade-up" data-aos-delay="300" v-html="$t('PAGE02_TEXT16')">The Eye Area is the
              #1 concern regardless of age</h3>
            <p data-aos="fade-up" data-aos-delay="300" v-html="$t('PAGE02_TEXT17')">To solve any problem you have to know the cause, understanding the
              vulnerabilities of the eye area will help you to select the perfect solution
              for your customers.</p>
          </div>
        </div>
        <div class="row mt-12">
          <div class="col-12">
            <div class="card-deck color-highlight" v-if="ageCardsActive === 1">
              <div class="card" data-aos="fade-right" data-aos-delay="120">
                <img src="@/assets/images/02/s03_p01.jpg" class="card-img" alt="...">
              </div>
              <div class="card " data-aos="fade-up" data-aos-delay="120">
                <div class="card-body d-flex flex-column justify-content-center">
                  <h4 class="text-uppercase" v-html="$t('PAGE02_TEXT18')">What they say</h4>
                  <p v-html="$t('PAGE02_TEXT19')"> “I have begun to notice dark circles - especially when I am tired”</p>
                  <p v-html="$t('PAGE02_TEXT20')">“Stress and lack of sleep make
                    them worse…”</p>
                </div>
              </div>
              <div class="card" data-aos="fade-up" data-aos-delay="120">
                <div class="card-body d-flex flex-column justify-content-center">
                  <h4 class="text-uppercase" v-html="$t('PAGE02_TEXT21')">What’s happening?</h4>
                  <p v-html="$t('PAGE02_TEXT22')">The natural exchange of fluids in
                    the eye area becomes sluggish
                    causing bluish circles and
                    puffiness, boosting circulation is
                    the answer.</p>
                </div>
              </div>
            </div>
            <div class="card-deck color-highlight" v-if="ageCardsActive === 2">
              <div class="card card__bg" data-aos="fade-up" data-aos-delay="120" :style="{'background-image': 'url(' + require('@/assets/images/02/s03_p02.jpg') + ')'}" >
                <img src="@/assets/images/02/s03_p02.jpg" class="card-img" alt="...">
              </div >
              <div class="card" data-aos="fade-up" data-aos-delay="120">
                <div class="card-body d-flex flex-column justify-content-center">
                  <h4 class="text-uppercase" v-html="$t('PAGE02_TEXT18')">What they say</h4>
                  <p v-html="$t('PAGE02_TEXT23')">“My concerns are changing, I can see new wrinkles developing around my eye area”</p>
                  <p v-html="$t('PAGE02_TEXT24')">“I have the feeling that aging is approaching quickly…”</p>
                </div>
              </div>
              <div class="card " data-aos="fade-up" data-aos-delay="120" >
                <div class="card-body d-flex flex-column justify-content-center">
                  <h4 class="text-uppercase mb-3" v-html="$t('PAGE02_TEXT21')">What’s happening?</h4>
                  <p v-html="$t('PAGE02_TEXT25')">Skin is naturally becoming drier and repeated facial expressions such as frowning cause more
                    permanent wrinkles to develop. Essential anti-aging fibres such as collagen also begin to decline,
                    the solution is to nourish and replenish lost essential fibres for an eye area that bounces back with
                    plumpness and resilience</p>
                </div>
              </div>
            </div>
            <div class="card-deck color-highlight" v-if="ageCardsActive === 3">
              <div class="card card__bg" data-aos="fade-up" data-aos-delay="120" :style="{'background-image': 'url(' + require('@/assets/images/02/s03_p03.jpg') + ')'}">
                <img src="@/assets/images/02/s03_p03.jpg" class="card-img" alt="...">
              </div>
              <div class="card" data-aos="fade-up" data-aos-delay="120">
                <div class="card-body d-flex flex-column justify-content-center">
                  <h4 class="text-uppercase" v-html="$t('PAGE02_TEXT18')">What they say</h4>
                  <p v-html="$t('PAGE02_TEXT26')">“I have new concerns, my eye area is beginning to sag, dark circles and wrinkles are more
                    pronounced and I have the classic ‘eye bags’ that make me look so tired.”</p>
                </div>
              </div>
              <div class="card" data-aos="fade-up" data-aos-delay="120">
                <div class="card-body d-flex flex-column justify-content-center">
                  <h4 class="text-uppercase" v-html="$t('PAGE02_TEXT21')">What’s happening?</h4>
                  <p v-html="$t('PAGE02_TEXT27')">As well as water metabolism and anti-aging fibers declining, the eye muscle also begins to decline
                    contributing to a new concern of sagging or eye bags, often referred to as age-related fatigue, the
                    solution is to lift, firm and tighten the eye area – discover how with the NEW Vital Perfection Eye
                    Experts</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row row--buttons mt-10">
          <div class="col-4 d-flex align-items-center justify-content-center">
            <div class="button d-flex align-items-center justify-content-center" v-on:click="changeAgeCard(1)"
                 :class="[ageCardsActive === 1 ? 'active' : '']">
              <p v-html="$t('PAGE02_TEXT28')">25/34<br><span>years old</span></p>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center justify-content-center">
            <div class="button d-flex align-items-center justify-content-center" v-on:click="changeAgeCard(2)"
                 :class="[ageCardsActive === 2 ? 'active' : '']">
              <p v-html="$t('PAGE02_TEXT29')">35/44<br><span>years old</span></p>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center justify-content-center">
            <div class="button d-flex align-items-center justify-content-center" v-on:click="changeAgeCard(3)"
                 :class="[ageCardsActive === 3 ? 'active' : '']">
              <p v-html="$t('PAGE02_TEXT30')">44+<br><span>years old</span></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section__allabouteyes section__allabouteyes--04 mb-5" :class="{'d-none': additionalContent == false}">
      <div class="container pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1 text-center">
            <p class="font-bold font-size-56 color-highlight mb-4" v-html="$t('PAGE02_TEXT31-1')">Eye Structure</p>
            <p class="mb-5" v-html="$t('PAGE02_TEXT31')">To become an Eye expert it is important to understand the eye structure and what happens as
              we age.</p>
            <p class="mb-5" v-html="$t('PAGE02_TEXT32')">Click on the boxes below to learn all about eyes</p>

            <button type="button" class="btn mr-0 mb-5 mb-md-0 mr-md-5" :class="[chapterActive === 1 ? 'active' : '']"
                    v-on:click="changeChapter(1)" v-html="$t('PAGE02_TEXT33')">young eye structure
            </button>
            <button type="button" class="btn mb-0 mb-md-5" :class="[chapterActive === 2 ? 'active' : '']"
                    v-on:click="changeChapter(2)" v-html="$t('PAGE02_TEXT34')">mature eye structure
            </button>
          </div>
        </div>
        <div class="row my-7">
          <div class="col-7 col-lg-5 offset-lg-1 d-flex align-items-center justify-content-center">
            <div class="d-flex flex-column eye__toggler" v-if="chapterActive === 1">
              <div class="box box--button" :class="[buttonActive === 1 ? 'active' : '']" v-on:click="buttonActive = 1"><p v-html="$t('PAGE02_TEXT35')">
                Muscle fibers are strong and supportive</p></div>
              <div class="box box--button" :class="[buttonActive === 2 ? 'active' : '']" v-on:click="buttonActive = 2"><p v-html="$t('PAGE02_TEXT36')">
                Fatty acids are removed efficiently
                by well functioning lymphatic vessels</p></div>
              <div class="box box--button" :class="[buttonActive === 3 ? 'active' : '']" v-on:click="buttonActive = 3"><p v-html="$t('PAGE02_TEXT37')">
                Water metabolism is efficient and
                waste matter is expelled efficiently</p></div>
              <div class="box box--button" :class="[buttonActive === 4 ? 'active' : '']" v-on:click="buttonActive = 4"><p v-html="$t('PAGE02_TEXT38')">
                Skin fibers are resilient and support
                well the structure of the eye</p></div>
            </div>
            <div class="d-flex flex-column eye__toggler" v-if="chapterActive === 2">
              <div class="box box--button" :class="[buttonActive === 1 ? 'active' : '']" v-on:click="buttonActive = 1"><p v-html="$t('PAGE02_TEXT39')">
                Muscle fibers become thinner and weaken</p></div>
              <div class="box box--button" :class="[buttonActive === 2 ? 'active' : '']" v-on:click="buttonActive = 2"><p v-html="$t('PAGE02_TEXT40')">
                Fatty acids build up in the skin as the lymphatic vessel
                function declines, causing fat cells to enlarge,
                their weight causes skin to sag.
              </p></div>
              <div class="box box--button" :class="[buttonActive === 3 ? 'active' : '']" v-on:click="buttonActive = 3"><p v-html="$t('PAGE02_TEXT41')">
                Water metabolism declines and stagnates
                and waste matter is no longer expelled efficiently
                and the eye area becomes puffy.
              </p></div>
              <div class="box box--button" :class="[buttonActive === 4 ? 'active' : '']" v-on:click="buttonActive = 4"><p v-html="$t('PAGE02_TEXT42')">
                Skin fibers decline resulting in loss of firmness
                and resilience and the skin is less able to support
                the eye structure
              </p></div>
            </div>
          </div>
          <div class="col-5 col-md-5 col-lg-4 d-flex align-items-center">
            <img src="@/assets/images/02/eye-mature-complete.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 2 && buttonActive === 0">
            <img src="@/assets/images/02/eye-mature-1-muscle-fibres.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 2 && buttonActive === 1">
            <img src="@/assets/images/02/eye-mature-2-fatty-acids.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 2 && buttonActive === 2">
            <img src="@/assets/images/02/eye-mature-3-water-metabolism.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 2 && buttonActive === 3">
            <img src="@/assets/images/02/eye-mature-4-skin-fibers.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 2 && buttonActive === 4">
            <img src="@/assets/images/02/eye-young-complete.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 1 && buttonActive === 0">
            <img src="@/assets/images/02/eye-young-complete-1-muscle-fibres.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 1 && buttonActive === 1">
            <img src="@/assets/images/02/eye-young-complete-2-fatty-acids.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 1 && buttonActive === 2">
            <img src="@/assets/images/02/eye-young-complete-3-water-metabolism.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 1 && buttonActive === 3">
            <img src="@/assets/images/02/eye-young-complete-4-skin-fibres.jpg" class="img-fluid" alt="..."
                 v-if="chapterActive === 1 && buttonActive === 4">

          </div>
        </div>
      </div>



    </section>
    <section class="section__allabouteyes section__allabouteyes--05 mt-20 mb-20" :class="{'d-none': additionalContent == false}">
      <div class="container pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1 text-center">
            <p class="font-size-56 mb-8" v-html="$t('PAGE02_TEXT43')">How can we help to defy
              the natural aging process ?
            </p>
            <p class="font-bold font-size-56 color-highlight" v-html="$t('PAGE02_TEXT44')">Let’s meet the new
              <span class="nobr"> Eye Care Experts !</span></p>
          </div>
        </div>
      </div>
    </section>

    <Footer :kapitel="'03'" :class="{'d-none': additionalContent == false}"/>

  </div>
</template>

<script>
import lrsService from "@/services/lrsService";
import Footer from "@/components/partials/Footer";
import jQuery from 'jquery';
export default {
  name: "page-020",
  components: {
    Footer
  },
  props: {
    kapitel: ""
  },
  data: function () {
    return {
      additionalContent: false,
      ageCardsActive: 1,
      chapterActive: 1,
      buttonActive: 0,
      tracking: [0,0,0,0,0],
      ageCardTracking: [1,0,0],
      chapterTracking: [1,0],
      moduleStatus: ''
    }
  },
  created() {
    this.$store.watch(
            (state, getters) => getters.moduleStatus,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.moduleStatus = newValue;
              for (let i = 0; i < this.moduleStatus.length; i++) {
                if(this.moduleStatus[i][0]  == '02'){
                  this.tracking = [1,1,1,1,1];
                  this.ageCardTracking = [1,1,1];
                  this.chapterTracking = [1,1];
                }
              }
            },
    );
  },
  mounted() {

    let _this = this;
    this.resetScrollIndicator();
    let answers = document.querySelectorAll('.answer');
    document.querySelectorAll('.answer').forEach(item => {
      item.addEventListener('click', event => {
        _this.selectAnswer(item)
      })
    })

    const section1 = this.$scrollmagic.scene({
      triggerElement: '.section__allabouteyes--01',
      triggerHook: 0,
      reverse:false
    }).on('start', function () {
      if(_this.tracking[0] == 0){
        _this.tracking[0] = 1;
        _this.incrementScrollIndicator(20);
      }

    });
    const section2 = this.$scrollmagic.scene({
      triggerElement: '.section__allabouteyes--02',
      triggerHook: 0,
      reverse:false
    }).on('start', function () {
      if(_this.tracking[1] == 0){
        _this.tracking[1] = 1;
        _this.incrementScrollIndicator(10);
      }
    });
    const section3 = this.$scrollmagic.scene({
      triggerElement: '.section__allabouteyes--03',
      triggerHook: 0,
      reverse:false
    }).on('start', function () {
      if(_this.tracking[2] == 0){
        _this.tracking[2] = 1;
        _this.incrementScrollIndicator(10);
      }
    });

    const section4 = this.$scrollmagic.scene({
      triggerElement: '.section__allabouteyes--04',
      triggerHook: 0,
      reverse:false
    }).on('start', function () {
      if(_this.tracking[3] == 0){
        _this.tracking[3] = 1;
        _this.incrementScrollIndicator(10);
      }
    })
    const section5 = this.$scrollmagic.scene({
      triggerElement: '.section__allabouteyes--05',
      triggerHook: 0,
      reverse:false
    }).on('start', function () {
      if(_this.tracking[4] == 0){
        _this.tracking[4] = 1;
        _this.incrementScrollIndicator(20);
      }
    })
    this.$scrollmagic.addScene(section1);
    this.$scrollmagic.addScene(section2);
    this.$scrollmagic.addScene(section3);
    this.$scrollmagic.addScene(section4);
    this.$scrollmagic.addScene(section5);

  },
  methods: {
    changeChapter(id){
      this.chapterActive = id;
      if(this.chapterTracking[id-1] == 0){
        this.chapterTracking[id-1] = 1;
        this.incrementScrollIndicator(10)
      }
    },
    changeAgeCard(id){
      let oldCard = this.ageCardsActive;
      this.ageCardsActive = id;
      if(this.ageCardTracking[id-1] == 0){
        this.ageCardTracking[id-1] = 1;
        this.incrementScrollIndicator(5)
      }

      let content = jQuery('.section__allabouteyes--03');
      let sectionOffset = jQuery(content).offset().top;
      let firstRowHeight = jQuery('.section__allabouteyes--03 > .container').children().eq(0).height();

      if(oldCard == 3){
        jQuery('html, body').animate({
          scrollTop: sectionOffset + firstRowHeight + 100
        }, 400);
      } else {
        jQuery('html, body').animate({
          scrollTop: sectionOffset + firstRowHeight + 80
        }, 400);
      }
    },
    selectAnswer(item){
      item.classList.toggle('selected');
    },
    showAdditionalContent(){
      this.additionalContent = true;
      this.incrementScrollIndicator(10)
      setTimeout(() => {
        this.refreshAOS();
        let offset = jQuery("#section__allabouteyes--02").offset().top;
        jQuery('html, body').animate({
          scrollTop: offset -50
        }, 400);
      }, 300);
    },

  },
  beforeMount() {
    this.resetScrollIndicator();
    this.moduleStatus = this.$store.getters.moduleStatus;
    for (let i = 0; i < this.moduleStatus.length; i++) {
      console.log(this.moduleStatus[i][0], this.kapitel)
      if(this.moduleStatus[i] == this.kapitel){
        this.tracking = [1,1,1,1,1];
        this.ageCardTracking = [1,1,1];
        this.chapterTracking = [1,1];
      }
    }
  }
}
</script>

<style scoped>

</style>